import axios from 'axios';

const BASE_URL = window.APP_CONFIG.INTERNAL_API_URL;

export async function getProductCoderef(name, key, productVersion) {
	const data = {
		Key: `UW::underwriting::${name}::${key}`,
		ProductVersionIdRef: productVersion,
	};

	const response = await axios.post(
		`${BASE_URL}/portal/getProductCoderef`,
		data
	);
	return response.data.data;
}

export async function createQuoteDB(data) {
	await axios.post(`${BASE_URL}/portal/createQuoteDB`, data);
}

export async function completeQuote(quoteNumber, statusCode = 'COMP') {
	const data = {
		Quote_Number: quoteNumber,
		Quote_Status_code: statusCode,
	};

	await axios.post(`${BASE_URL}/portal/updateQuoteDB`, data);
}

export async function updatePersonalInfoQuote(data) {
	await axios.post(`${BASE_URL}/portal/updateQuoteDB`, data);
}

export async function sendEmail(formData) {
	await axios.post(`${BASE_URL}/EmailSender/sendEmail`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
}

export async function createAdditionalQuote(quote) {
	const formData = new FormData();
	formData.append('request', quote);
	const response = await fetch(`${BASE_URL}/portal/createQuote`, {
		method: 'POST',
		body: formData,
	});
	const responseJson = await response.json();
	return responseJson;
}

export async function createQuote(quote) {
	window.localStorage.setItem('hazard_hub_data', 'no');
	const formData = new FormData();
	formData.append('request', quote);
	let response;
	await fetch(`${BASE_URL}/portal/createQuote`, {
		method: 'POST',
		body: formData,
	})
		.then((res) => res.json())
		.then(
			(result) => {
				response = result;

				if (result[0].toString() === 'ERROR') {
					response = {
						status: 'ERROR',
					};
				} else {
					window.localStorage.setItem(
						'quote_number',
						result[0].DTOApplication[0].ApplicationNumber
					);

					let noOfStories, buildingArea, yearBuilt, constructionType;
					//hazardhub data
					const dataReportRequest =
						result[0].DTOApplication[0].DataReportRequest[0];
					if (
						'HazardHubRs' in dataReportRequest &&
						'AssessmentDetail' in dataReportRequest.HazardHubRs[0]
					) {
						const assessmentDetail =
							dataReportRequest.HazardHubRs[0]
								.AssessmentDetail[0];
						noOfStories = assessmentDetail.NoOfStories;
						buildingArea = assessmentDetail.BuildingArea;
						yearBuilt = assessmentDetail.YearBuilt;
						constructionType = assessmentDetail.ConstructionType;
						window.localStorage.setItem('hazard_hub_data', 'yes');
						window.localStorage.setItem(
							'hazard_hub_data_used',
							'no'
						);
					}

					window.localStorage.setItem(
						'customer_ref',
						result[0].DTOApplication[0].CustomerRef
					);

					window.localStorage.setItem(
						'quote_information',
						JSON.stringify({
							firstYearPremium:
								result[0].DTOApplication[0].DTOBasicPolicy[0]
									.FinalPremiumAmt,
							secondYearPremium:
								result[0].DTOApplication[0].DTOLine[0]
									.EstimatedSecondYearAssessment,
							fiveYearPremium:
								result[0].DTOApplication[0].DTOLine[0]
									.EstimatedFiveYearAveAnnualCost,
							num_stories: noOfStories,
							sqft: buildingArea,
							build_year: yearBuilt,
							found_type:
								result[0].DTOApplication[0].DTOLine[0]
									.DTORisk[0].DTOBuilding[0].FoundationType,
							construction_type: constructionType,
							personal_information:
								result[0].DTOApplication[0].CustomerRef,
						})
					);

					response = { status: 'SUCCESS', data: result[0] };
				}
			},
			(error) => {
				response = {
					status: 'Error',
					message:
						'Service temporarily unavailable. Please try again later.',
				};
			}
		);

	return response;
}

export async function retrieveQuote(quote) {
	const formData = new FormData();
	formData.append('request', quote);
	let response;
	await fetch(`${BASE_URL}/portal/retrieveQuote`, {
		method: 'POST',
		body: formData,
	})
		.then((res) => res.json())
		.then(
			(result) => {
				response = result;
				let index = 0;

				if (result[0].toString() === 'ERROR') {
					response = 'ERROR';
				} else if (
					result[0].DTOApplication.length > 1 &&
					quote.QuoteNumber == undefined
				) {
					response = 'MULTIPLE_QUOTES';
				} else if (result[0].DTOApplication.length === 0) {
					response = 'ERROR';
				} else {
					if (result[0].DTOApplication.length > 1) {
						result[0].DTOApplication((app, i) => {
							if (app.ApplicationNumber === quote.QuoteNumber) {
								index = i;
							}
						});
					}

					window.localStorage.setItem(
						'quote_number',
						result[0].DTOApplication[index].ApplicationNumber
					);

					window.localStorage.setItem(
						'quote_information',
						JSON.stringify({
							firstYearPremium:
								result[0].DTOApplication[index]
									.DTOBasicPolicy[0].FinalPremiumAmt,
							secondYearPremium:
								result[0].DTOApplication[index].DTOLine[0]
									.EstimatedSecondYearAssessment,
							fiveYearPremium:
								result[0].DTOApplication[index].DTOLine[0]
									.EstimatedFiveYearAveAnnualCost,
							num_stories:
								result[0].DTOApplication[index].DTOLine[0]
									.DTORisk[0].DTOBuilding[0].NumberOfStories,
							sqft: result[0].DTOApplication[index].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].SqFt,
							build_year:
								result[0].DTOApplication[index].DTOLine[0]
									.DTORisk[0].DTOBuilding[0].YearBuilt,
							found_type:
								result[0].DTOApplication[index].DTOLine[0]
									.DTORisk[0].DTOBuilding[0].FoundationType,
							personal_information:
								result[0].DTOApplication[0].CustomerRef,
						})
					);

					let middle_name = '';
					if (
						result[0].DTOApplication[
							index
						].DTOInsured[0].PartyInfo[0].NameInfo.find(
							(e) => e.NameTypeCd === 'InsuredName'
						).OtherGivenName !== undefined
					) {
						middle_name =
							result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredName'
							).OtherGivenName + ' ';
					}

					window.localStorage.setItem(
						'personal_information',
						JSON.stringify({
							first_name: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredName'
							).GivenName,
							last_name: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredName'
							).Surname,
							mi: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredName'
							).OtherGivenName,
							co_applicant: false,
							co_first_name: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[1].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredNameJoint'
							).GivenName,
							co_last_name: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[1].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredNameJoint'
							).Surname,
							co_mi: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[1].NameInfo.find(
								(e) => e.NameTypeCd === 'InsuredNameJoint'
							).OtherGivenName,
							email: result[0].DTOApplication[index].DTOInsured[0]
								.PartyInfo[0].EmailInfo[0].EmailAddr,
							phone: result[0].DTOApplication[index].DTOInsured[0]
								.PartyInfo[0].PhoneInfo[0].PhoneNumber,
							main_addr_street: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredBillingAddr'
							).Addr1,
							main_addr_city: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredBillingAddr'
							).City,
							main_addr_zip: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredBillingAddr'
							).PostalCode,
							main_addr_state: 'Florida',
							mail_addr: false,
							mail_addr_street: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredMailingAddr'
							).Addr1,
							mail_addr_city: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredMailingAddr'
							).City,
							mail_addr_zip: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredMailingAddr'
							).PostalCode,
							mail_addr_state: 'Florida',
							prior_addr: false,
							prior_addr_street: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredPriorAddr'
							).Addr1,
							prior_addr_city: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredPriorAddr'
							).City,
							prior_addr_zip: result[0].DTOApplication[
								index
							].DTOInsured[0].PartyInfo[0].Addr.find(
								(e) => e.AddrTypeCd === 'InsuredPriorAddr'
							).PostalCode,
							prior_addr_state: 'Florida',
							personal_information:
								result[0].DTOApplication[0].CustomerRef,
						})
					);

					response = 'SUCCESS';
				}
			},
			(error) => {
				response = 'ERROR';
			}
		);

	return response;
}

export async function retrieveQuotes(customerRef) {
	if (!customerRef) return '';
	const formData = new FormData();
	const content = JSON.stringify({
		customerId: customerRef,
	});
	formData.append('request', content);

	try {
		const response = await fetch(`${BASE_URL}/portal/retrieveQuotes`, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			return 'Error';
		}

		const responseJson = await response.json();
		const applicationNumbers = responseJson.applicationListItems.map(
			(i) => i.applicationMini.applicationNumber
		);
		const filteredNumbers = await filterRetrievableQuoteNumbers(
			applicationNumbers
		);
		responseJson.applicationListItems =
			responseJson.applicationListItems.filter((i) =>
				filteredNumbers.includes(i.applicationMini.applicationNumber)
			);
		return responseJson;
	} catch (error) {
		console.log(error);
	}
}

async function filterRetrievableQuoteNumbers(quoteNumbers) {
	const formData = new FormData();
	quoteNumbers.forEach((q) => formData.append('quoteNumbers', q));

	try {
		const response = await fetch(
			`${BASE_URL}/portal/filterRetrievableQuoteNumbers`,
			{
				method: 'POST',
				body: formData,
			}
		);

		if (!response.ok) {
			return 'Error';
		}

		const filteredQuoteNumbers = await response.json();
		return filteredQuoteNumbers;
	} catch (error) {
		console.log(error);
	}
}

export async function retrieveCustomer(myData) {
	const formData = new FormData();
	formData.append('request', JSON.stringify(myData));
	let response;
	await fetch(`${BASE_URL}/portal/retrieveCustomer`, {
		method: 'POST',
		body: formData,
	})
		.then((response) => response.json())
		.then((data) => {
			response = data;
		})
		.catch((error) => {
			response = 'Error';
		});

	return response;
}

export async function retrieveCustomerByRef(ref) {
	const formData = new FormData();
	formData.append('request', JSON.stringify(ref));
	let response;
	await fetch(`${BASE_URL}/portal/retrieveCustomerByRef`, {
		method: 'POST',
		body: formData,
	})
		.then((response) => response.json())
		.then((data) => {
			response = data;
		})
		.catch((error) => {
			response = 'Error';
		});

	return response;
}

export async function updateCustomerByRef(data) {
	const ref = {
		Customer_Ref: data.Customer_Ref,
	};
	let customer = await retrieveCustomerByRef(ref);
	if (customer === 'Error') return 'Error';

	let customerFullName =
		data.Insured_First_Name + ' ' + data.Insured_Last_Name;
	if (
		data.Insured_MI_Name !== '' &&
		data.Insured_MI_Name !== null &&
		data.Insured_MI_Name !== 'null' &&
		data.Insured_MI_Name !== undefined
	)
		customerFullName =
			data.Insured_First_Name +
			' ' +
			data.Insured_MI_Name +
			' ' +
			data.Insured_Last_Name;

	customer.indexName = customerFullName;
	customer.partyInfo[0].personInfo.birthDt = data.Birth_Dt;
	customer.partyInfo[0].emailInfo.emailAddr = data.Email;
	customer.partyInfo[0].phoneInfo[0].phoneNumber = data.Phone;
	customer.partyInfo[0].nameInfo.givenName = data.Insured_First_Name;
	customer.partyInfo[0].nameInfo.otherGivenName = data.Insured_MI_Name;
	customer.partyInfo[0].nameInfo.surname = data.Insured_Last_Name;
	customer.partyInfo[0].nameInfo.commercialName = customerFullName;

	const formData = new FormData();
	formData.append('request', JSON.stringify(customer));
	let response;
	await fetch(`${BASE_URL}/portal/updateCustomer/${data.Customer_Ref}`, {
		method: 'POST',
		body: formData,
	})
		.then((response) => response.json())
		.then((data) => {
			response = data;
		})
		.catch((error) => {
			response = 'Error';
		});

	return response;
}

export async function fetchQuote(quote) {
	const formData = new FormData();
	formData.append('request', quote);
	let response;
	await fetch(`${BASE_URL}/portal/fetchQuote`, {
		method: 'POST',
		body: formData,
	})
		.then((res) => res.json())
		.then(
			(result) => {
				response = result.DTOApplication[0];

				if (!localStorage.getItem('personal_information')) {
					localStorage.setItem(
						'personal_information',
						JSON.stringify({
							first_name:
								response.DTOInsured[0].PartyInfo[0].NameInfo.find(
									(e) => e.NameTypeCd === 'InsuredName'
								).GivenName,
							last_name:
								response.DTOInsured[0].PartyInfo[0].NameInfo.find(
									(e) => e.NameTypeCd === 'InsuredName'
								).Surname,
							email: response.DTOInsured[0].PartyInfo[0]
								.EmailInfo[0].EmailAddr,
							phone: response.DTOInsured[0].PartyInfo[0]
								.PhoneInfo[0].PhoneNumber,
						})
					);
				}
			},
			(error) => {
				response = 'Error';
			}
		);

	return response;
}

export async function updateQuote(quote) {
	const formData = new FormData();
	formData.append('request', quote);
	let response;
	await fetch(`${BASE_URL}/portal/updateQuote`, {
		method: 'POST',
		body: formData,
	})
		.then((res) => res.json())
		.then(
			(result) => {
				response = result[0];

				window.localStorage.setItem(
					'quote_information',
					JSON.stringify({
						firstYearPremium:
							result[1].DTOApplication[0].DTOBasicPolicy[0]
								.FinalPremiumAmt,
						secondYearPremium:
							result[1].DTOApplication[0].DTOLine[0]
								.EstimatedSecondYearAssessment,
						fiveYearPremium:
							result[1].DTOApplication[0].DTOLine[0]
								.EstimatedFiveYearAveAnnualCost,
						num_stories:
							result[1].DTOApplication[0].DTOLine[0].DTORisk[0]
								.DTOBuilding[0].NumberOfStories,
						sqft: result[1].DTOApplication[0].DTOLine[0].DTORisk[0]
							.DTOBuilding[0].SqFt,
						build_year:
							result[1].DTOApplication[0].DTOLine[0].DTORisk[0]
								.DTOBuilding[0].YearBuilt,
						found_type:
							result[1].DTOApplication[0].DTOLine[0].DTORisk[0]
								.DTOBuilding[0].FoundationType,
						construction_type:
							result[1].DTOApplication[0].DTOLine[0].DTORisk[0]
								.DTOBuilding[0].ConstructionCd,
						personal_information:
							result[1].DTOApplication[0].CustomerRef,
					})
				);
			},
			(error) => {
				response = 'Error';
			}
		);

	return response;
}

export async function getToken(quote) {
	const formData = new FormData();
	formData.append('request', quote);
	let response;
	await fetch(`${BASE_URL}/portal/getToken`, {
		method: 'POST',
		body: formData,
	})
		.then((res) => res.json())
		.then(
			(result) => {
				if (result[0] === 'SUCCESS') {
					response = result[1].toString();
				} else {
					response = result[0]; // ERROR
				}
			},
			(error) => {
				response = 'Error';
			}
		);

	return response;
}

export async function getGoogleApiKey() {
	let response;
	await fetch(`${BASE_URL}/portal/getGoogleAPIKey`, {
		method: 'GET',
	})
		.then((res) => res.json())
		.then(
			(result) => {
				response = result;
			},
			(error) => {
				response = 'Error';
			}
		);

	return response;
}

export async function verifyAddress(address) {
	const formData = new FormData();
	formData.append('request', address);

	const result = await handleRequest(
		fetch(`${BASE_URL}/portal/verifyAddress`, {
			method: 'POST',
			body: formData,
		})
	);

	return result;
}

export async function handleRequest(fetch) {
	try {
		const response = await fetch;
		const data = await response.json().catch((e) => console.log(e));
		if (!response.ok) {
			return {
				success: false,
				data: null,
				error:
					data?.message ||
					`Request failed with status ${response.status}`,
			};
		}

		if (data?.success === false) {
			return {
				success: false,
				data: null,
				error: data.message || 'Unknown business error',
			};
		}

		return {
			success: true,
			data: data.data,
			error: null,
		};
	} catch (err) {
		return {
			success: false,
			data: null,
			error: err.message || 'Unknown network error',
		};
	}
}

export async function getApplicationCorrespondence(quote) {
	const formData = new FormData();
	formData.append('request', quote);
	let response;
	await fetch(`${BASE_URL}/portal/getApplicationCorrespondence`, {
		method: 'POST',
		body: formData,
	})
		.then((res) => res.json())
		.then(
			(result) => {
				if (result[0] === 'SUCCESS') {
					response = result[1].toString();
				} else {
					response = result[0]; // ERROR
				}
			},
			(error) => {
				response = 'Error';
			}
		);

	return response;
}

export function createActivityQuoteDB(page_name, activity_code, description) {
	fetch(`${BASE_URL}/portal/createActivityQuoteDB`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			Quote_number: localStorage.getItem('quote_number'),
			Page_Name: page_name,
			Activity_Code: activity_code,
			Source_IP: localStorage.getItem('user_ip'),
			Session_ID: localStorage.getItem('session_id'),
			Description: description,
		}),
	});
}
